import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import styled from 'styled-components';
export const PlanWrapper = styled.div `
  s-box {
    border-width: 2px;
  }
  ${({ disabled }) => !disabled && 'cursor: pointer;'}
  ${({ selected, disabled }) => selected && !disabled && `
    s-box {
      border: 2px ${COLORS.blue} solid;
      box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    }
  `}
`;
export const FixedWidthPlanWrapper = styled(PlanWrapper) `
  width: 260px;
`;
